import { shallowEqual, useSelector } from "react-redux";
import { UserModel } from "services/api/cplauthapi/CPLAuthAPI";
import { RootState } from "setup";

const useAutosaveKey = (formKey: string) => {
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel;
  return `cpl-autosave-${formKey}-${user.userID}`;
};

export default useAutosaveKey;
